<template>
    <div id="nova">
        <MainHeader />

        <!-- Content -->
        <div id="content" dusk="content">
            <div
                class="hidden lg:absolute left-0 bottom-0 lg:top-[56px] lg:bottom-auto w-60 px-3 py-8"
                :class="{ 'lg:block': !sidebarCollapsed }"
            >
                <!-- The Main Menu on desktop gets extra padding to keep the bottom of the sidebar from feeling crowded -->
                <MainMenu class="pb-24" data-screen="desktop" />
            </div>

            <div
                class="p-4 md:py-8 md:px-12 space-y-8"
                :class="{ 'lg:ml-60': !sidebarCollapsed }"
            >
                <Breadcrumbs v-if="breadcrumbsEnabled" />

                <FadeTransition>
                    <slot />
                </FadeTransition>

                <Footer />
            </div>
        </div>
    </div>
</template>

<script>
import MainHeader from "@/layouts/MainHeader";
import Footer from "@/layouts/Footer";

export default {
    components: {
        MainHeader,
        Footer,
    },

    data: () => ({
        // The page original overflow value
        originalOverflow: null,
        parentElements: [],
    }),

    mounted() {
        Nova.$on("error", this.handleError);
        Nova.$on("token-expired", this.handleTokenExpired);

        window.navigation.addEventListener("navigate", () => {
            setTimeout(() => {
                const url = window.history.state.url;
                if (url.includes("/rapprochement-paie-ij")) {
                    if (url.includes("/rapprochement-paie-ij?display=admin") && !this.sidebarCollapsed) {
                        this.$store.commit("toggleSidebar");
                    } else if (url.includes("/rapprochement-paie-ij?display=client") && this.sidebarCollapsed) {
                        this.$store.commit("toggleSidebar");
                    }

                    // Change the overflow of the html element to hidden to prevent scrolling
                    if (document.documentElement.style.overflow !== 'hidden') {
                        this.originalOverflow = document.documentElement.style.overflow;
                    }
                    document.documentElement.style.overflow = "hidden";

                    setTimeout(() => {
                        this.waitForElement('#plan-de-relance-resource-table').then((table) => {
                            let parent = table.parentElement;

                            for (let i = 1; i < 14; i++) {
                                if (i === 1) {
                                    parent.style.overflowY = 'auto';
                                    parent.style.height = '100%';
                                } else if (i === 2) {
                                    parent.style.height = '84%';
                                } else if (i === 3) {
                                    parent.style.height = '74%';
                                } else {
                                    parent.style.height = '100%';
                                }

                                parent = parent.parentElement;
                            }

                            const thead = table.querySelector('thead');
                            thead.style.position = 'sticky';
                            thead.style.top = 0;
                            thead.style.zIndex = 1;
                        });
                    }, 2500);
                } else {
                    if (this.sidebarCollapsed) {
                        this.$store.commit("toggleSidebar");
                    }

                    document.querySelector('#content').style.height = null;

                    if (this.originalOverflow !== null) {
                        // Restore the overflow of the html element
                        document.documentElement.style.overflow = this.originalOverflow;
                    }
                }
            }, 100);

        });
    },

    beforeUnmount() {
        Nova.$off("error", this.handleError);
        Nova.$off("token-expired", this.handleTokenExpired);
    },

    methods: {
        handleError(message) {
            Nova.error(message);
        },

        handleTokenExpired() {
            // @TODO require Nova._createToast() to support action with link.
            Nova.$toasted.show(this.__("Sorry, your session has expired."), {
                action: {
                    onClick: () => Nova.redirectToLogin(),
                    text: this.__("Reload"),
                },
                duration: null,
                type: "error",
            });

            setTimeout(() => {
                Nova.redirectToLogin();
            }, 5000);
        },

        waitForElement(selector) {
            return new Promise(resolve => {
                if (document.querySelector(selector)) {
                    return resolve(document.querySelector(selector));
                }

                const observer = new MutationObserver(mutations => {
                    if (document.querySelector(selector)) {
                        observer.disconnect();
                        resolve(document.querySelector(selector));
                    }
                });

                // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            });
        }
    },

    computed: {
        breadcrumbsEnabled() {
            return Nova.config("breadcrumbsEnabled");
        },
        sidebarCollapsed: function () {
            return this.$store.getters.sidebarCollapsed;
        },
    },
};
</script>
